import React from 'react';
import format from 'string-template';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { BRAND_NAME } from '../../../constants';
import { HeadComponent } from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import UnsubscribeFormComponent from './UnsubscribeFormComponent';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

import './UnsubscribePage.scss';

export class UnsubscribePage extends React.Component {
    render() {
        const { i18n } = this.props;

        return (
            <main className="conteneur conteneur-mobile" id="p-desabonnement">
                <HeadComponent title={i18n.TITLE} description={i18n.DESCRIPTION} />
                <LocalizedBreadcrumbItem to={PATH.UNSUBSCRIBE_PATH}>
                    {i18n.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <h1>{i18n.PAGE_TITLE}</h1>
                <h3>{format(i18n.SUBTITLE, BRAND_NAME)}</h3>
                <p>{format(i18n.MSG_CONFIRMATION, BRAND_NAME)}</p>
                <UnsubscribeFormComponent />
            </main>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.UNSUBSCRIBE
    };
};

export default withTemplate(connect(mapStateToProps)(UnsubscribePage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/unsubscribe/UnsubscribePage.js